import React from 'react';
import cn from 'classnames';

import { Spinner } from 'src/components/animations/Spinner';

import type { HotelMapLoaderProps as Props } from './types';
import styles from './hotelMapLoader.module.css';

export const HotelMapLoader = ({ className = '' }: Props) => (
  <div className={cn(className, styles.container)}>
    <Spinner />
  </div>
);
